import React, { useEffect, useState } from "react";
import SelectAutomationCard from "./SelectAutomationCard";
import "../automation.css";
import {
  getWorkflowTemplates,
  getWorkflowTemplatesCount,
} from "api/WorkflowApi";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
var offset = 0;
var matchNextButton = 1;

export default function SelectAutomation() {
  const [workflowTemplates, setWorkflowTemplates] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    getWorkflowTemplates(offset, pageSize)
      .then((res) => {
        setWorkflowTemplates(res);
      })
      .catch((e) => { });
    getWorkflowTemplatesCount()
      .then((res) => {
        setPageCount(Math.ceil(res.count / pageSize));
      })
      .catch((e) => { });
  }, [pageSize]);

  const nextPage = (e) => {
    e.preventDefault();
    offset += pageSize;
    matchNextButton++;
    getWorkflowTemplates(offset, pageSize)
      .then((res) => {
        setWorkflowTemplates(res);
      })
      .catch((e) => { });
  };
  const previousPage = (e) => {
    e.preventDefault();
    offset -= pageSize;

    getWorkflowTemplates(offset, pageSize)
      .then((res) => {
        matchNextButton--;
        setWorkflowTemplates(res);
      })
      .catch((e) => { });
  };

  const gotoPage = (e, page) => {
    e.preventDefault();
    offset = page * pageSize;
    matchNextButton = page + 1;
    getWorkflowTemplates(offset, pageSize)
      .then((res) => {
        setWorkflowTemplates(res);
      })
      .catch((e) => { });
  };

  const canGoNext = () => {
    if (matchNextButton >= pageCount) {
      return false;
    } else {
      return true;
    }
  };

  const canGoPrevious = () => {
    if (offset === 0) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <label className="large ml-3">Select Template</label>
      <div style={{ textAlign: "end" }}>
        Page {matchNextButton} of {pageCount}
      </div>
      <div
        className="container selectAutomationContainer"
        style={{
          width: "100%",
          minHeight: "600px",
          marginTop: "20px",
          paddingLeft: "0px",
          paddingRight: "0px",
        }}
      >
        {workflowTemplates.map((workflowTemplate) => {
          return (
            <SelectAutomationCard
              name={workflowTemplate.name}
              description={workflowTemplate.description}
              workflowTemplateId={workflowTemplate.id}
              icon_url={workflowTemplate.icon}
            />
          );
        })}
      </div>
      <div className="pagination">
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
        <button
          onClick={(e) => gotoPage(e, 0)}
          disabled={!canGoPrevious()}
          className="gotofirst"
        >
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                First Page
              </Tooltip>
            )}
          >
            <i className="fa fa-angle-double-left"></i>
          </OverlayTrigger>
        </button>
        <button
          onClick={(e) => previousPage(e)}
          disabled={!canGoPrevious()}
          className="gotoprevious"
        >
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                Previous
              </Tooltip>
            )}
          >
            <i className="fa fa-angle-left"></i>
          </OverlayTrigger>
        </button>{" "}
        <button
          onClick={(e) => nextPage(e)}
          disabled={!canGoNext()}
          className="gotonext"
        >
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                Next
              </Tooltip>
            )}
          >
            <i className="fa fa-angle-right"></i>
          </OverlayTrigger>
        </button>{" "}
        <button
          onClick={(e) => gotoPage(e, pageCount - 1)}
          disabled={!canGoNext()}
          className="gotolast"
        >
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                Last Page
              </Tooltip>
            )}
          >
            <i className="fa fa-angle-double-right"></i>
          </OverlayTrigger>
        </button>{" "}
      </div>
    </>
  );
}
